<template>

</template>

<script>
export default {
    name: "Alignment"
}
</script>

<style scoped>

</style>